/* eslint-disable max-len */
import { Menu } from '@headlessui/react'
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { timeZoneMap } from '../../CommonComponent/staticValues';
import moment from 'moment/moment';

export default function TableRow(props){

    const { bidders }= props;
    const [selectedRow, setSelectedRow]=useState(null);
    const Navigate = useNavigate()

    const convertTimestampToDayMonthYear = (time_zone,timestamp) => {

        if(timestamp==0|| !timestamp) {
            return '-';
        }

        const time =moment.tz(timestamp, timeZoneMap[time_zone ? time_zone : 'Etc/GMT'] || time_zone || 'Etc/GMT').format("MMM DD YYYY")
        return time.includes('1970') ? '-' : time;
    };
    
    return(
        <>
            {bidders.map((bidder,index)=>
                <tr key={index} 
                    className={`border border-[#DEDEDE] border-b-0 table-row  h-8 
                    hover:bg-[#F4F4F5] ${selectedRow===index ? 'bg-[#F4F4F5]' : ''} `}>
                    <td onClick={()=>Navigate(`/allbidders/${bidder._id}`)}
                        className=" text-[#343434] pl-12 pr-4 py-2 text-[14px] leading-normal font-medium cursor-pointer hover:underline">
                        {bidder.name === '' || bidder.name === undefined || bidder.name === ' '? '-': bidder.name}</td>
                    <td className=" text-[#343434] px-4 py-2 text-[14px] leading-normal font-medium">
                        {bidder.email_address}</td>
                    <td className=" text-[#343434] px-4 py-2 text-[14px] leading-normal font-medium">
                        {convertTimestampToDayMonthYear(bidder.time_zone,bidder.created_at)}
                    </td>
                    <td className=" text-[#343434] pl-4 pr-9 pb-2 pt-4 h-[67px] text-[14px] text-center leading-normal font-medium 
                    flex items-center justify-center" >
                        <img src={`/images/${bidder.marketing === true ? 'truemark.svg' :'falsemark.svg'} `} alt=""  />
                    </td>
                    <td className=" sm:relative sm:bg-transparent bg-[#fff] sticky top-0 right-0 h-[50px]
                      justify-center">
                        <div className="h-full sm:shadow-none shadow-bs7 sm:px-8">
                            <span className="flex md:justify-end justify-center translate-y-[100%]">
                                <Menu as="div" className="relative" >
                                    <Menu.Button onClick={()=>setSelectedRow(index)} >
                                        <img src="/images/three-dots-icon-black.svg" alt="img" 
                                            className="cursor-pointer three-dots-icon action-bar" type="button"
                                            id="action_bar" data-testid={`action-bar-${index}`} />
                                    </Menu.Button>
                                    <Menu.Items>
                                        <div className="dropdown-cont absolute overflow-hidden rounded-[10px] float-left 
                                                    m-0 w-[150px] py-2 min-w-max right-0 z-[50] px-2
                                                    list-none  border-none bg-white bg-clip-padding 
                                                    text-left text-base shadow-bs3">
                                            <Menu.Item data-testid='view-bidder'>
                                                <button type='button' onClick={()=>Navigate(`/allbidders/${bidder._id}`)}
                                                    className="block w-full whitespace-nowrap bg-transparent pl-3 pr-5 py-2 
                                                            text-[12px] font-medium text-[#343434] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]">
                                                    View</button>
                                            </Menu.Item>
                                            <Menu.Item data-testid='delete-buyer'>
                                                <button type='button'
                                                    className="block w-full whitespace-nowrap bg-transparent pl-3 pr-5 py-2 
                                                            text-[12px] font-medium text-[#343434] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]">
                                                    Delete</button>
                                            </Menu.Item>
                                        </div>
                                    </Menu.Items>
                                </Menu>
                            </span>  
                        </div> 
                    </td>
                </tr>
            )}
        </>
    );
}